<mat-card *ngIf="taskList" style="padding: 0 0 24px 0;">
  <mat-toolbar [color]="secondary">
    Tasques
    <button style="margin-left: auto; margin-right: 0" mat-icon-button matTooltip="Afegeix una nova tasca" aria-label="Afegeix una nova tasca" matTooltipClass="tooltip-style">
      <mat-icon>add</mat-icon>
    </button>
    <button mat-icon-button matTooltip="Visualitza totes les tasques" aria-label="Visualitza totes les tasques" matTooltipClass="tooltip-style">
      <mat-icon>list</mat-icon>
    </button>
    <button matTooltip="Edita una tasca" aria-label="Edita una tasca" matTooltipClass="tooltip-style" mat-icon-button>
      <mat-icon>mode_edit</mat-icon>
    </button>
  </mat-toolbar>
  <mat-card-content style="padding: 0px 24px;">
    <mat-list>
      <mat-list-item *ngIf="taskList.length === 0">
        No hi ha tasques associades al treball
      </mat-list-item>
      <mat-list-item *ngFor="let task of taskList; let i = index;">
        <h2 mat-line>
          {{task.DESCR}}
        </h2>
        <p mat-line>
          {{task.PERSONA}} - {{task.TEMPS | number}} hores
        </p>
        <mat-divider *ngIf="i !== taskList.length - 1"></mat-divider>
      </mat-list-item>
    </mat-list>
  </mat-card-content>
</mat-card>
